// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ElementosDocumentosPdf_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /config/elementos_documentos_pdf/salvar
 * (Vue 3 endpoint).
 *
 * Returns `{ name }` identifying the saved/created PDF page element.
 * Mirrors the legacy Vue wire shape `dados: { name: '<element-name>' }`.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ElementosDocumentosPdf_SalvarResponseDados {
name: string
}

export type ElementosDocumentosPdf_SalvarResponse = ApiResponse<ElementosDocumentosPdf_SalvarResponseDados>;

registerResponseContract('ElementosDocumentosPdf_SalvarResponse', {
  name: { type: 'string',  required: true },
})
